'use strict';

class VerificacionAnticipoModalController {
  constructor($uibModalInstance, $scope, DataService, Message, data, _, Util, Supervision, Big, decimales,$log) {
    'ngInject';
    this.$uibModalInstance = $uibModalInstance;
    this.$scope = $scope;
    this.DataService = DataService;
    this.Message = Message;
    this._ = _;
    this.Util = Util;
    this.Supervision = Supervision;
    this.Big = Big;
    this.decimales = decimales;
    this.supervision = data.supervision;
    this.deudaAnticipo = data.deudaAnticipo;
    this.totalDescuentos = data.totalDescuentos;
    this.esPlanillaCierre = data.esPlanillaCierre;
    this.errorRedondeo = data.errorRedondeo;
    this.$log=$log;
  }

  $onInit() {
    this.tiposDescuento = [
      {codigo: 'TOTAL', nombre: `Por la totalidad del anticipo ${this.supervision.supervisiones_anteriores.length > 0 ? 'pendiente' : ''} (*)`},
      {codigo: 'PROGRESIVO', nombre: 'Progresivo (**)'},
    ];
    this.verificarSiPuedeDescuentoTotal();
    this.verSiPuedeDescuentoProgresivo();
    if (this.esPlanillaCierre) {
      this.calcularDescuento('TOTAL');
    }
  }

  verificarSiPuedeDescuentoTotal() {
    if (this.supervision.monto_total_actual_ejecutado < this.deudaAnticipo) {
      this.$log.log('verificarSiPuedeDescuentoTotal');
      this.puedeDescuentoTotal = false;
      this.supervision.tipo_descuento_anticipo = 'PROGRESIVO';
      this.calcularDescuento('PROGRESIVO');
    } else {
      this.supervision.tipo_descuento_anticipo = null;
      this.puedeDescuentoTotal = true;
    }
  }

  verSiPuedeDescuentoProgresivo() {
    this.$log.log('verSiPuedeDescuentoProgresivo');
    this.puedeDescuentoProgresivo = this.esValidoDescuentoProgresivo();
    if (!this.puedeDescuentoProgresivo) {
      this.supervision.tipo_descuento_anticipo = 'TOTAL';
      this.calcularDescuento('TOTAL');
    }
  }

  esValidoDescuentoProgresivo() {
    this.$log.log('esValidoDescuentoProgresivo');
    this.calcularDescuento('PROGRESIVO');
    if (this.desembolso.descuento > this.deudaAnticipo || this.esPlanillaCierre) {
      return false;
    }
    this.desembolso = null;
    return true;
  }

  calcularDescuento(tipo) {
    this.$log.log('calcularDescuento');
    this.$log.log('tipo',tipo);
    this.$log.log('monto actual',this.supervision.monto_total_actual_ejecutado);
    this.$log.log('deuda anticipo',this.deudaAnticipo);
    this.$log.log('porcentaje anticipo', this.supervision.proyecto.porcentaje_anticipo);
    this.desembolso = this.Supervision.calcularDescuento(tipo, this.supervision.monto_total_actual_ejecutado, this.deudaAnticipo, this.supervision.proyecto.porcentaje_anticipo);
    if (this.supervision.monto_total_actual_ejecutado==0)
    {
      this.supervision.porcentaje_descuento=0;
      this.supervision.tipo_descuento_anticipo=0;
    }
    else
    {
      if(['TOTAL','PROGRESIVO'].indexOf(tipo)>=0) {
        this.supervision.porcentaje_descuento = this.Big(this.desembolso.descuento).div(this.supervision.monto_total_actual_ejecutado).mul(100).toFixed(2);
      } else {
        this.supervision.tipo_descuento_anticipo = tipo;
      }
    }
  }

  getPorcentaje(numero, porcentaje) {
    //return this.Util.redondear(this.Util.redondear(numero * porcentaje)/100);
    return parseFloat(this.Big(numero).mul(porcentaje).div(100).toFixed(this.decimales||2));
  }

  cerrar() {
    this.$uibModalInstance.dismiss('cancel');
  }

  registrar() {
    this.$uibModalInstance.close(this.supervision);
  }

  tieneComputosMetricos() {
    return !this._.isEmpty(JSON.parse(angular.toJson(this.computos))[0]);
  }
}

export default VerificacionAnticipoModalController;



// WEBPACK FOOTER //
// ./src/app/components/empresas/planilla-proyecto/verificacion-anticipo.modal.controller.js